<template>
  <div>
    <keep-alive :include="hasView">
      <router-view />
    </keep-alive>
    <footer-con></footer-con>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import footerCon from '@/components/footer'
export default {
  name: 'Layout',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['hasView']),
    key() {
      return this.$route.fullPath
    }
  },
  components: {
    footerCon,
  },
  mounted() {},
  methods: {},
  beforeRouteLeave (to, from, next) {
    if (to.name === 'projetList'){
      this.$store.dispatch('saveView', ['Home']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  }
};
</script>
<style lang="" scoped>
</style>